import Immutable from 'immutable';
import React, { PureComponent } from 'react';
import Form from '../../forms/form';

const EMPTY_LIST = Immutable.List([]);

let sequence = 1;

export default function FormDefinition() {
	if (!(this instanceof FormDefinition)) {
		return new FormDefinition();
	}

	let basePath = [];
	let items;
	let calculateProperties;
	let horizontal; // ?? to se asi nepouziva - je to primo v render contextu
	let actionMode;
	let validator;
	let actionListener;
	let virtual = true;
	let opacityCallback;
	let opacity;


	const formKey = ++sequence;

	this.setHorizontal = function(value) {
		horizontal = value;
		return this;
	};

	this.setActionListener = function(value) {
		actionListener = value;
		return this;
	};

	this.setVirtual = function(value) {
		virtual = value;
		return this;
	};

	this.setOpacity = function(value) {
		if (typeof value === 'function') {
			opacityCallback = value;
			opacity = null;
		} else {
			opacityCallback = null;
			opacity = value;
		}
		return this;
	};

	const getOpacity = function(ctx) {
		if (opacityCallback) {
			return opacityCallback(ctx);
		} else {
			return opacity;
		}
	}

	this.processCalcProperties = function(ctx) {
		if (calculateProperties) {
			ctx.mergeCalcProperties(calculateProperties(ctx));
		}
	};

	this.setActionMode = function(value) {
		actionMode = value;
		return this;
	};

	this.setValidator = function(value) {
		if (value && !value.isContextValidator) {
			throw 'Only context validator allowed in FormDefinition';
		}
		validator = value;
		return this;
	};

	this.setBasePath = function(value) {
		if (value === null || value === undefined) {
			value = [];
		} else if (!Array.isArray(value)) {
			value = [ value ];
		}
		basePath = value;
		return this;
	};

	this.setItems = function(value) {
		items = Immutable.List(value);
		items.forEach(item => {
			item._parentDefinition = this;
		});
		return this;
	};

	this.setCalculateProperties = function(value) {
		calculateProperties = value;
		return this;
	};

	this.getItems = function() {
		return items || EMPTY_LIST;
	};

	const validate = function(errors, ctx, itemName) {
		if (validator) {
			validator.validate(errors, ctx, itemName);
		}
	};

	this.validateAll = function(ctx, errors) {
		ctx = ctx.withAppendedBasePath(basePath);
		this.processCalcProperties(ctx);
		validate(errors, ctx);
		items.forEach(item => {
			item.validateAll(ctx, errors);
		});
	};

	this.validateOnChange = function(ctx, errors, itemName) {
		validate(errors, ctx, itemName);
		if (this._parentDefinition && this._parentDefinition.validateOnChange) {
			this._parentDefinition.validateOnChange(ctx.withShortenedBasePath(basePath.length), errors, itemName)
		}
	};

	this.render = function(ctx, key = 0) {
		ctx = ctx.withAppendedBasePath(basePath);
		this.processCalcProperties(ctx);
		return <FormWrapper
			definition={this}
			renderContext={ctx}
			key={key}
			formKey={formKey}
			horizontal={horizontal}
			actionMode={actionMode}
			virtual={virtual}
			opacity={getOpacity(ctx)}
			onAction={() => {
				if (actionListener) {
					actionListener({
						source: 'form',
						ctx
					});
				}
				ctx.trigger('action', {
					source: 'form'
				});
			}}
		/>;
	};
}

class FormWrapper extends PureComponent {
	render() {
		const definition = this.props.definition;
		const ctx = this.props.renderContext;
		return (
			<Form
				key={this.props.formKey}
				horizontal={this.props.horizontal}
				actionMode={this.props.actionMode}
				onAction={this.props.onAction}
				virtual={this.props.virtual}
				opacity={this.props.opacity}
			>
				{
					definition.getItems().map((item, index) => item.render(ctx, index))
				}
			</Form>
		);
	}
}
